import React from 'react';
import { Flex } from '@indeed/ifl-components';
import { SystemStyleObject } from '@indeed/ifl-css';

export interface OptionCardGroupProps {
    sx?: SystemStyleObject;
}

export const OptionCardGroup: React.FC<React.PropsWithChildren<OptionCardGroupProps>> = ({
    children,
    sx,
}) => (
    <Flex
        as="fieldset"
        role="radiogroup"
        sx={{ border: 0, flexDirection: 'column', p: 0, rowGap: 3, ...sx }}
        tabIndex={-1}
    >
        {children}
    </Flex>
);
